import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import moment from "moment";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
// Constants - Functions
import { WEB_SERVICE_MIMS } from "../../../config/constants";
// Components
import {
  Form,
  TitleTextDiv,
  TextP,
  DataDiv,
  ColumnDataDiv,
  InputDataDiv,
  Label,
  DateInputDiv,
  DateInput,
  ReactTooltipStyled,
  SaveDiv,
  SaveButton,
} from "./styles";
import Axios from "../../../config/axios";

const ReferenceDates = ({ referenceDates }) => {
  const [armProgressReferenceDate, setArmProgressReferenceDate] = useState("");
  const [armCostReferenceDate, setArmCostReferenceDate] = useState("");
  // Variable to set the next 7 days from progress reference date
  const [weekAfterArmCostReferenceDate, setWeekAfterArmCostReferenceDate] = useState([]);

  const { patientId } = useParams();
  const [t] = useTranslation("global");

  const handleSetWeekAfterArmCostReferenceDate = (date) => {
    const daysToHighlight = 7;
    const datesToHighlight = Array.from({ length: daysToHighlight }, (_, i) => new Date(date.getTime() + (i + 1) * 24 * 60 * 60 * 1000));
    setWeekAfterArmCostReferenceDate(datesToHighlight);
  };

  // Fetch reference dates
  useEffect(() => {
    if (referenceDates.length) {
      const armProgressReferenceDate = referenceDates.filter((referenceDate) => referenceDate.REFERENCE_KEY === "armProgressReferenceDate");
      if (armProgressReferenceDate.length) {
        setArmProgressReferenceDate(new Date(armProgressReferenceDate[0].REFERENCE_DATE));
      }

      const armCostReferenceDateArray = referenceDates.filter((referenceDate) => referenceDate.REFERENCE_KEY === "armCostReferenceDate");
      if (armCostReferenceDateArray.length) {
        const armCostReferenceDate = new Date(armCostReferenceDateArray[0].REFERENCE_DATE);
        setArmCostReferenceDate(armCostReferenceDate);
        handleSetWeekAfterArmCostReferenceDate(armCostReferenceDate);
      }
    }
  }, [referenceDates]);

  const onChangeArmProgressReferenceDate = (date) => {
    setArmProgressReferenceDate(date ? date : "");
  };

  const onChangeArmCostReferenceDate = (date) => {
    setArmCostReferenceDate(date ? date : "");
    if (date) handleSetWeekAfterArmCostReferenceDate(date);
  };

  const highlightDatesOnHover = (date) => {
    if (date) handleSetWeekAfterArmCostReferenceDate(date);
  };

  const closeArmCostReferenceCalendar = () => {
    if (armCostReferenceDate) handleSetWeekAfterArmCostReferenceDate(armCostReferenceDate);
  };

  const saveReferenceDates = (e) => {
    e.preventDefault();

    const armReferencesToStore = [
      {
        REFERENCE_KEY: "armProgressReferenceDate",
        REFERENCE_DATE: armProgressReferenceDate ? moment(armProgressReferenceDate).format("YYYY-MM-DD") : "",
      },
      {
        REFERENCE_KEY: "armCostReferenceDate",
        REFERENCE_DATE: armCostReferenceDate ? moment(armCostReferenceDate).format("YYYY-MM-DD") : "",
      },
    ];

    Axios("post", `${WEB_SERVICE_MIMS}/arm-reference-date/add/${patientId}`, armReferencesToStore)
      .then(({ data }) => {
        if (data.addedArmReferenceDate) toast.success(t("wear_referenceDates_correctlySavedMessage"));
      })
      .catch((error) => {
        toast.error(t("sendDataErrorMessage"));
        console.log("Endpoint to add reference dates: ", error);
      });
  };

  return (
    <Form onSubmit={saveReferenceDates}>
      <TitleTextDiv>
        <TextP>{t("wear_referenceDates_title")}</TextP>
      </TitleTextDiv>
      <DataDiv>
        <ColumnDataDiv>
          <InputDataDiv>
            <Label fontWeight="bold" data-for="armActivityPrompt" data-tip={t("wear_referenceDates_labelHover1")}>
              {t("wear_referenceDates_label1")} *
            </Label>
            <ReactTooltipStyled id="armActivityPrompt" place="top" type="dark" effect="solid" delayShow={100} delayHide={100} />
            <DateInputDiv>
              <DateInput selected={armProgressReferenceDate} onChange={onChangeArmProgressReferenceDate} dateFormat={"dd/MM/yyyy"} />
            </DateInputDiv>
          </InputDataDiv>
          <InputDataDiv>
            <Label fontWeight="bold" data-for="armPointCostPrompt" data-tip={t("wear_referenceDates_labelHover2")}>
              {t("wear_referenceDates_label2")} *
            </Label>
            <ReactTooltipStyled id="armPointCostPrompt" place="top" type="dark" effect="solid" delayShow={100} delayHide={100} />
            <DateInputDiv>
              <DateInput
                selected={armCostReferenceDate}
                onChange={onChangeArmCostReferenceDate}
                highlightDates={weekAfterArmCostReferenceDate}
                dateFormat={"dd/MM/yyyy"}
                onDayMouseEnter={highlightDatesOnHover}
                onCalendarClose={closeArmCostReferenceCalendar}
              />
            </DateInputDiv>
          </InputDataDiv>
        </ColumnDataDiv>
      </DataDiv>
      <SaveDiv>
        <SaveButton type="submit">{t("save")}</SaveButton>
      </SaveDiv>
    </Form>
  );
};

export default ReferenceDates;
